import makeStyles from "@mui/styles/makeStyles";
export const useItemDetailStyles = makeStyles((theme) => ({
    customHoverFocus: {
        "&.MuiIconButton-root": {
            backgroundColor: "#ffffff",
            padding: "0px",
            boxShadow: "2px 2px 10px rgba(84, 84, 84, 0.2);",
        },
        "&:hover, &.Mui-focusVisible": {
            backgroundColor: "rgba(255,225,255,.6);",
        },
    },
    itemDetailModal: {
        "& .MuiDialogActions-root": {
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
        },
        "& .MuiDialog-scrollPaper": {
            alignItems: "flex-start",
        },
        "& .MuiDialog-paper": {
            marginTop: "10%",
        },
        "& .MuiDialog-paperScrollPaper": {
            minWidth: "300px",
            maxHeight: "calc(90% - 64px)",
        },
    },
    sliderImage: {
        float: "left",
        width: "100%",
        height: "100%",
        maxHeight: "250px",
        objectFit: "cover",
        objectPosition: "center center",
        textAlign: "center",
        fontSize: "0px",
    },
    tabs: (props) => ({
        "&.MuiTabs-root": {
            position: props.hasImages ? "absolute" : "relative",
            background: !props.hasImages ? "#eee" : undefined,
            paddingTop: props.hasImages ? 0 : theme.spacing(2),
            bottom: "0px",
            left: "0px",
            minHeight: "38px",
        },
        "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: "400",
            background: "#d9d9d9",
            margin: "0px 2px",
            minWidth: "1px",
            minHeight: "38px",
            padding: "6px 12px",
            borderRadius: "10px 10px 0px 0px",
            opacity: "1",
        },
        "& .Mui-selected": {
            background: "#fff",
        },
        "& .MuiTabs-indicator": {
            backgroundColor: "#fff",
        },
    }),
}));
